/** Internal dependencies */
import { getHeaderHeight } from '../../../../../../assets/src/scripts/utilities';

export function setHeroSliderHeight() {
    const herosliderItems = document.querySelectorAll('.ct_slider.heroslider .ct_slideritem');

    if (!herosliderItems) {
        return;
    }

    const headerHeight = getHeaderHeight();

    herosliderItems.forEach((slide) => {
        slide.style.height = `calc(100vh - ${headerHeight}px)`;
    });
}
